<template>
  <header>
    <div class="cd_container cd_header-container">
      <Logo />
      <Nav />
    </div>
  </header>
</template>

<script>
  import Logo from './logo';
  import Nav from './nav';

  export default {
    name: 'Header',
    components: {
      Logo,
      Nav
    }
  }
</script>
